//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Vue from 'vue'
import {Message} from 'element-ui'
Vue.prototype.$message = Message

import SideMenu from '@/components/pc/el-side-menu'
import Breadcrumb from '@/components/pc/el-breadcrumb'
export default {
  name: 'desktop-layout',
  components: {SideMenu, Breadcrumb},
  data() {
    return {
      no_sidebar: false
    }
  },
  methods: {
    toggleSidebar() {
      this.no_sidebar = !this.no_sidebar
    }
  },
  created() {
    if (window.innerWidth < 800) {
      this.no_sidebar = true
    }
  },
  mounted() {
    
  }
}



// WEBPACK FOOTER //
// ./src/layout/desktop-layout.vue